// extracted by mini-css-extract-plugin
module.exports = {"container":"badNews_container__tUUpp","icon":"badNews_icon__N8GT5"};